import * as React from 'react'
import { connect } from 'react-redux'
import type { Campaign } from 'types/content-editor'
import { updateCampaignEditorGlobalProps } from '@disco/state-management/actions/campaign-editor-actions'
import {
  DEFAULT_FONT_FAMILY,
  DEFAULT_LINE_HEIGHT,
  FONT_FAMILY_OPTIONS,
  lineHeightOptions,
} from '@disco/constants/content-editor'
import { getCampaignEditorState } from '@disco/state-management/selectors/campaigns'
import {
  getFontSize,
  getSectionPaddings,
} from '@disco/content-editor/editor-utils'
import ColorInput from 'components/ui/color-input'
import Dropdown from 'components/ui/dropdowns/native-dropdown'
import Input from 'components/ui/input'
import Label from 'components/ui/label'

const mapStateToProps = state => ({
  campaign: getCampaignEditorState(state),
})

class GlobalSettingsTab extends React.Component<{
  campaign: Campaign
  updateCampaignEditorGlobalProps: typeof updateCampaignEditorGlobalProps
}> {
  _changeBackgroundColor = (color: { hex: string }) => {
    this.props.updateCampaignEditorGlobalProps({
      generalBackground: color.hex,
    })
  }
  _changeRegularProp = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.props.updateCampaignEditorGlobalProps({
      [e.target.name]: e.target.value,
    })
  }
  _onFontFamilySelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    this.props.updateCampaignEditorGlobalProps({
      fontFamily: e.target.value,
    })
  }
  _onLineHeightSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    this.props.updateCampaignEditorGlobalProps({
      lineHeight: parseFloat(e.target.value),
    })
  }

  render() {
    const { campaign } = this.props
    const { h, v } = getSectionPaddings(null, campaign)
    return (
      <div className="editor-block-list">
        <div className="content-editor__section-settings__body">
          <div className="content-editor__section-settings__list">
            <div className="rich-text-toolbar__settings__list__row">
              <Label caption="Background color" />
              <div className="content-editor__section-settings__list__value">
                <ColorInput
                  name="color"
                  portal
                  value={campaign.generalBackground || '#fff'}
                  onChange={this._changeBackgroundColor}
                />
              </div>
            </div>
            <div className="rich-text-toolbar__settings__list__row">
              <Label caption="Font family" />
              <div className="content-editor__section-settings__list__value">
                <Dropdown
                  className="SelectDropdown toolbar-dropdown"
                  options={FONT_FAMILY_OPTIONS}
                  value={campaign.fontFamily || DEFAULT_FONT_FAMILY}
                  onChange={this._onFontFamilySelect}
                />
              </div>
            </div>
            <div className="rich-text-toolbar__settings__list__row">
              <Label caption="Font size (px)" />
              <div className="content-editor__section-settings__list__value">
                <Input
                  className="Campaigns_LargeInput"
                  name="fontSize"
                  defaultValue={getFontSize(null, campaign)}
                  value={campaign.fontSize}
                  onChange={this._changeRegularProp}
                />
              </div>
            </div>
            <div className="rich-text-toolbar__settings__list__row">
              <Label caption="Line height" />
              <div className="content-editor__section-settings__list__value">
                <Dropdown
                  className="SelectDropdown toolbar-dropdown"
                  options={lineHeightOptions}
                  value={(
                    campaign.lineHeight || DEFAULT_LINE_HEIGHT
                  ).toString()}
                  onChange={this._onLineHeightSelect}
                />
              </div>
            </div>
            <div className="rich-text-toolbar__settings__list__row">
              <Label caption="Vertical padding (px)" />
              <div className="content-editor__section-settings__list__value">
                <Input
                  className="Campaigns_LargeInput"
                  name="verticalPadding"
                  defaultValue={v}
                  value={campaign.verticalPadding}
                  onChange={this._changeRegularProp}
                />
              </div>
            </div>
            <div className="rich-text-toolbar__settings__list__row">
              <Label caption="Horizontal padding (px)" />
              <div className="content-editor__section-settings__list__value">
                <Input
                  className="Campaigns_LargeInput"
                  name="horizontalPadding"
                  defaultValue={h}
                  value={campaign.horizontalPadding}
                  onChange={this._changeRegularProp}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, {
  updateCampaignEditorGlobalProps,
})(GlobalSettingsTab) as any
